import { products } from '../constants';
import { getEnv } from '../components/Context/env';

export default (currentSubscription, freeTrial, newSignUp = false) => {
  const env = getEnv();

  if ([products.credit_expert, products.identity].includes(currentSubscription) || freeTrial) {
    return env.REACT_APP_HOME_URL;
  }

  if ([products.breach, products.breachPlus].includes(currentSubscription)) {
    return `${env.REACT_APP_IDENTITY_URL}${newSignUp ? '/?newSignUp=1' : ''}`;
  }

  return env.REACT_APP_C2_URL;
};
